"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistrictItem = void 0;
var React = require("react");
var styles_1 = require("@/pages/guides/components/DistrictItem/styles");
exports.DistrictItem = function (_a) {
    var districtItem = _a.districtItem;
    var districtName = districtItem.districtName, url = districtItem.url;
    return (React.createElement(styles_1.Container, { href: url }, districtName));
};
